import router from '@/router/router'

export class Navigation {

	// Opens a new tab or Routes to the Company Details page
	static toCompanyDetailsScreen(companyId: number | null | undefined, newTab?: boolean) {
		if (!companyId)
			return;

		if (newTab) {
			const routeData = router.resolve({
				name: 'CompanyDetails',
				params: { companyId: companyId }
			});
			window.open(routeData.href, '_blank');
		}
		else {
			router.push({
				name: 'CompanyDetails',
				params: { companyId }
			});
		}
	}

	// Opens a new tab or Routes to the Property Details page
	static toPropertyDetailsScreen(propertyId: number | null | undefined, newTab?: boolean) {
		if (!propertyId)
			return;

		if (newTab) {
			const routeData = router.resolve({
				name: 'PropertyDetails',
				params: { propertyId }
			});
			window.open(routeData.href, '_blank');
		}
		else {
			router.push({
				name: 'PropertyDetails',
				params: { propertyId }
			});
		}
	}
}